<!--
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-16 16:40:19
 * @Description:
-->
<template>
  <div>
    <span class="card-head-txt">小括狐权益包：</span>
    <ul class="card-types">
      <li v-for="item in list" :key="item.cardType">
        <CardTypeNum :card-type="item.cardType" :expiring-soon-tip="item.expiringSoonTip" :expire-number="item.expireNumber" :residue-number="item.residueNumber" />
        <div class="card-type-split" />
      </li>
    </ul>
  </div>
</template>
<script>
import CardTypeNum from '@/components/CardTypeNum.vue'
import cardquity from '@/service/cardquity/index'
export default {
  components: {
    CardTypeNum
  },
  props: {
    noTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [
        {
          cardType: 11,
          residueNumber: '--'
        },
        {
          cardType: 12,
          residueNumber: '--'
        },
        {
          cardType: 16,
          residueNumber: '--'
        },
        {
          cardType: 17,
          residueNumber: '--'
        },
        {
          cardType: 18,
          residueNumber: '--'
        }
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let { list } = this
      list = list.filter(l => !this.noTypes.includes(l.cardType))
      const res = await cardquity.getInsQuota({ cardType: list.map(item => item.cardType) })
      console.log('res', res)
      this.$emit('dataChange', res)
      if (res.length) {
        this.list = res
      }
    }
  }
}
</script>
<style lang="less" scoped>
.card-head-txt {
  font-weight: 700;
  font-size: 12px;
  color: #303858;
}
.card-types {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;
  li {
    display: flex;
    align-items: center;
    &:last-child {
      margin-right: 0;
      .card-type-split {
        display: none;
      }
    }
    .card-type-split {
      width: 0px;
      height: 16px;
      border-left: 1px solid #DFE2E6;
      margin: 0 30px;
    }
  }
}
</style>